import React from 'react';


const LoginHeader = () => {
  return (
    <div className="text-center space-y-3 md:space-y-4">
      <div className="flex justify-center">
        <img 
          src="/assets/images/ORIN_LOGO-1777609908143.png" 
          alt="American Logics Logo" 
          className="h-12 md:h-14 w-auto object-contain"
        />
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground">
          ORIN
        </h1>
        <p className="text-sm md:text-base text-muted-foreground font-body max-w-md mx-auto">
          Decision Intelligence System
        </p>
      </div>

      <div className="pt-2">
        <h2 className="text-lg md:text-xl font-heading font-medium text-foreground">
          Sign in to your account
        </h2>
        <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">
          Access comprehensive analytics and performance insights
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;